"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setFaqCategories = exports.selectFAQByID = exports.selectAllFaqCategories = exports.selectFaqCategories = exports.deleteKnowledgeCategory = exports.updateKnowledgeCategory = exports.createKnowledgeCategory = exports.faqCategorySliceConfig = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var firestore_1 = require("firebase/firestore");
var lodash_1 = __importDefault(require("lodash"));
var moment_1 = __importDefault(require("moment"));
var firestore;
var faqCategorySliceConfig = function (_firebaseApp) {
    firestore = (0, firestore_1.getFirestore)(_firebaseApp);
};
exports.faqCategorySliceConfig = faqCategorySliceConfig;
// CRUD - Create, Read, Update, Delete
exports.createKnowledgeCategory = (0, toolkit_1.createAsyncThunk)('knowledgeCategory/create', function (category, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var state, companyID, user, data, companyDocRef, faqCategoryCollectionRef;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                state = thunkAPI.getState();
                companyID = state.setting.activeWorkspaceID;
                user = state.me.details;
                data = {
                    name: category.name,
                    createdAt: firestore_1.Timestamp.fromDate(new Date()),
                    createdBy: user === null || user === void 0 ? void 0 : user.uid,
                    createdByName: (user === null || user === void 0 ? void 0 : user.displayName) || '',
                };
                companyDocRef = (0, firestore_1.doc)((0, firestore_1.collection)(firestore, 'companies'), companyID);
                faqCategoryCollectionRef = (0, firestore_1.collection)(companyDocRef, 'faqCategories');
                return [4 /*yield*/, (0, firestore_1.addDoc)(faqCategoryCollectionRef, data)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); });
exports.updateKnowledgeCategory = (0, toolkit_1.createAsyncThunk)('knowledgeCategory/update', function (category, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var state, companyID, user, faqCategoryDocRef, createdAt, dataToUpdate;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                state = thunkAPI.getState();
                companyID = state.setting.activeWorkspaceID;
                user = state.me.details;
                faqCategoryDocRef = (0, firestore_1.doc)(firestore, 'companies', companyID, 'faqCategories', category.id);
                createdAt = category.createdAt, dataToUpdate = __rest(category, ["createdAt"]);
                return [4 /*yield*/, (0, firestore_1.updateDoc)(faqCategoryDocRef, __assign(__assign({}, dataToUpdate), { createdAt: firestore_1.Timestamp.fromDate((0, moment_1.default)(createdAt).toDate()), updatedAt: firestore_1.Timestamp.fromDate(new Date()), updatedBy: user === null || user === void 0 ? void 0 : user.uid, updatedByName: (user === null || user === void 0 ? void 0 : user.displayName) || '' }))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); });
exports.deleteKnowledgeCategory = (0, toolkit_1.createAsyncThunk)('knowledgeCategory/delete', function (arg, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var state, companyID;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                state = thunkAPI.getState();
                companyID = state.setting.activeWorkspaceID;
                return [4 /*yield*/, (0, firestore_1.deleteDoc)((0, firestore_1.doc)(firestore, 'companies', companyID, 'faqCategories', arg.cateogryId))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); });
var initialState = {
    initialised: false,
    faqCategories: [],
};
var faqCategorySlice = (0, toolkit_1.createSlice)({
    name: 'faqCategory',
    initialState: initialState,
    reducers: {
        setFaqCategories: {
            reducer: function (state, action) {
                if (action.payload) {
                    state.faqCategories = action.payload;
                    state.initialised = true;
                }
            },
            prepare: function (payload) {
                if (payload) {
                    var categoryModels = payload.map(function (cate) {
                        var _a, _b, _c, _d, _e, _f;
                        return ({
                            id: (_a = cate.id) !== null && _a !== void 0 ? _a : '',
                            name: (_b = cate.name) !== null && _b !== void 0 ? _b : '',
                            createdBy: cate.createdBy || '',
                            createdAt: (cate === null || cate === void 0 ? void 0 : cate.createdAt) instanceof firestore_1.Timestamp ? (_d = (_c = cate.createdAt) === null || _c === void 0 ? void 0 : _c.toDate().toISOString()) !== null && _d !== void 0 ? _d : '' : '',
                            createdByName: cate.createdByName || '',
                            updatedBy: cate.updatedBy || '',
                            updatedAt: (cate === null || cate === void 0 ? void 0 : cate.updatedAt) instanceof firestore_1.Timestamp ? (_f = (_e = cate.updatedAt) === null || _e === void 0 ? void 0 : _e.toDate().toISOString()) !== null && _f !== void 0 ? _f : '' : '',
                            updatedByName: cate.updatedByName || '',
                        });
                    });
                    return { payload: categoryModels };
                }
                return { payload: null };
            },
        },
    },
});
// Selectors
var selectFaqCategories = function (state) { return state.faqCategory.faqCategories; };
exports.selectFaqCategories = selectFaqCategories;
exports.selectAllFaqCategories = (0, toolkit_1.createSelector)(exports.selectFaqCategories, function (categories) {
    return lodash_1.default.orderBy(categories, ['createdAt'], 'desc');
});
exports.selectFAQByID = (0, toolkit_1.createSelector)(exports.selectAllFaqCategories, function (categories) {
    return function callbackFunction(cateId) {
        var cate = categories.find(function (cate) { return cate.id === cateId; });
        return cate !== null && cate !== void 0 ? cate : null;
    };
});
// Actions
exports.setFaqCategories = faqCategorySlice.actions.setFaqCategories;
exports.default = faqCategorySlice.reducer;
